module.exports = __webpack_public_path__ + "img/environment5.b5a507ff.png";